<template>
  <div>
    <el-tag v-if="['inactive'].includes(status)" type="info">Inativo</el-tag>
    <el-tag v-if="['new'].includes(status)" type="warning">Novo</el-tag>
    <el-tag v-if="['risk_analysis', 'bank_account', 'acquirers', 'gateway'].includes(status)" type="warning">
      <span v-if="isBeneficiary">Análise de Risco</span>
      <span v-else>Processando</span>
    </el-tag>
    <el-tag v-if="['risk_analysis_error', 'bank_account_error', 'acquirers_error', 'gateway_error'].includes(status)" type="danger">Erro</el-tag>
    <el-tag v-if="['risk_analysis_reproved', 'risk_analysis_rejected', 'bank_account_reproved', 'acquirers_reproved','gateway_reproved'].includes(status)" type="danger">Reprovado</el-tag>
    <el-tag v-if="['plan_reproved', 'terminal_reproved'].includes(status)" type="danger">Aguardando Associação</el-tag>
    <el-tag v-if="['risk_analysis_manually'].includes(status)" type="warning">Análise Manual</el-tag>
    <el-tag v-if="['risk_analysis_awaiting'].includes(status)" type="warning">Aguardando Documentação</el-tag>
    <el-tag v-if="['risk_analysis_approved', 'bank_account_approved', 'acquirers_approved', 'gateway_approved'].includes(status)" type="success">Aprovado</el-tag>
    <el-tag v-if="['active'].includes(status)" type="success">
      <span v-if="isBeneficiary">Ativo</span>
      <span v-else>Credenciamento Finalizado</span>
    </el-tag>
    <el-tag v-if="['cancelled'].includes(status)" type="danger">Cancelado</el-tag>
  </div>
</template>

<script>
export default {
  name: "StatusCapta",
  props: {
    status: {
      type: String,
      required: true,
      default: 'new'
    },
    isBeneficiary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
  